import React, { } from "react";
import { capitalizeFirstLetter } from "../../../../../utils/common"
import "./index.scss";
const Head = ({ plan }) => {

    return (
        <>
            <div className="head">
                <h3>{plan?.type && capitalizeFirstLetter(plan?.type)}</h3>
                <h4>
                    <label>
                        ${plan?.price} <span>/ {plan?.frequency}</span>
                    </label>
                </h4>
                <p>
                    {plan?.description}
                </p>
            </div>
        </>
    )
};
export default Head;